import React, { useState, Fragment } from 'react';
import { useSelector } from 'react-redux';
import isEqual from 'lodash.isequal';
import get from 'lodash.get';
import CouponButton from './CouponButton';
import PopupLayer from '../common/PopupLayer';
import CouponBanner from './CouponBanner';
import CouponPartner from './Partner/CouponPartner';
import {
  getCouponLayerOptions,
  checkPartnerCoupon,
} from '../../../app/Helper/CouponHelper';

/**
 * 쿠폰 할인 컴포넌트
 */
function CouponDiscount() {
  const { couponsSummary } = useSelector(
    state => ({
      couponsSummary: state.default.couponsSummary
        ? state.default.couponsSummary.response
        : {},
    }),
    isEqual
  );

  const { issuableCoupon = {}, partnerCoupon = {}, bannerList = {} } = get(
    couponsSummary,
    ['data', TMON.htStaticData.sDealNo],
    {}
  );

  const isCouponDisplay =
    !TMON.oApp.oUtil.isEmpty(issuableCoupon) &&
    issuableCoupon.couponDisplaySummary.displayType !== 'NONE';
  const isPartnerDisplay = checkPartnerCoupon(partnerCoupon);
  const isBannerDisplay = !TMON.oApp.oUtil.isEmpty(bannerList);
  const isMetaPriceDescription = TMON.htCommonStaticInfo.meta.isMetaPriceDescription();

  // 팝업 레이어
  const [isCouponLayerOpen, setIsCouponLayerOpen] = useState(false);

  const handleCloseCouponLayer = () => {
    setIsCouponLayerOpen(false);
  };

  return (
    <Fragment>
      {isCouponDisplay ||
      isBannerDisplay ||
      isPartnerDisplay ? (
        <div className="deal_info_unit coupon">
          <div className="info_unit_title">
            <h3 className="title">쿠폰할인</h3>
          </div>
          <div className="info_unit_contents">
            {/* 파트너 부담 쿠폰 */}
            {isPartnerDisplay && !isMetaPriceDescription &&  (
              <CouponPartner coupon={partnerCoupon.couponDisplaySummary} />
            )}
            {/* 쿠폰 */}
            {isCouponDisplay && (
              <div className="info_unit_bind">
                <CouponButton
                  title="쿠폰할인"
                  coupons={issuableCoupon}
                  isPartnerDisplay={isPartnerDisplay}
                  setIsLayerOpen={setIsCouponLayerOpen}
                  layerOptions={getCouponLayerOptions()}
                />
                {isCouponLayerOpen && (
                  <PopupLayer
                    title="쿠폰할인"
                    onClose={handleCloseCouponLayer}
                    popupKey="coupon"
                    layerOptions={{
                      ...getCouponLayerOptions(),
                    }}
                  />
                )}
              </div>
            )}
            {/* 배너  */}
            {isBannerDisplay &&
              bannerList.map(banner => (
                <CouponBanner key={banner} banner={banner} />
              ))}
          </div>
        </div>
      ) : null}
    </Fragment>
  );
}

export default CouponDiscount;
